import { Component, inject, OnInit } from '@angular/core';
import { BmsDataCollectorViewData } from '@core/models/bms-data-collector-view-data';
import { BmsDataUtils } from '../../../utils/bms-data-utils';
import { DateHelper } from 'xproj-lib';
import { BmsDataCollectorComponent } from '../../../bms-data-collector-view.component';

@Component({
  selector: 'app-bms-external-automation-parameters',
  templateUrl: './bms-myrspoven-external-automation-parameters.component.html',
  styleUrls: ['./bms-myrspoven-external-automation-parameters.component.scss']
})
export class BmsMyrspovenExternalAutomationParametersComponent implements OnInit, BmsDataCollectorComponent {

  private dateHelper: DateHelper = inject(DateHelper);

  public static NodeTypeId : string = '_x_bms_systems_myrspovensetpoint';

  data: BmsDataCollectorViewData;
  visible: boolean;

  keyPrefix : string = '';
  systemId : string;

  responsiveWidth : number = 600;

  constructor() { }

  ngOnInit() {
  }

  initDataCollectorView() {
    this.responsiveWidth = this.data.width;
    if (this.data.node) {
      let p = this.data.node.propertyValues.find(x => x.key == 'key');
      if (p) {
        this.keyPrefix = BmsDataUtils.getPropertyValue(p.valueType, p.value, this.dateHelper);
      }
      p = this.data.node.propertyValues.find(x => x.key == 'systemid');
      if (p) {
        this.systemId = BmsDataUtils.getPropertyValue(p.valueType, p.value, this.dateHelper);
      }
    }
  }

  setWidth(width: number) {
    if (this.data) {
      this.data.width = width;
    }

    this.responsiveWidth = width;
  }


}
